module.exports = __webpack_public_path__ + "static/media/alert.c18ee7ab.svg";